const ChooseLink = ({
	links,
	reset,
}) => {

	if (!links) return null;

	return <>
		<div className="services-modal__grid">
			{links.map(l => (
				<a key={l.slug} href={l.url} className="services-modal__grid-item services-modal__page-link">
					{l?.image && <img src={l.image} alt="" />}
					<span>{l.name}</span>
				</a>
			))}
		</div>

		<button className="services-modal__back-btn" onClick={reset}>
			<svg width="10" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path d="M2.00033 7.85547C2.00033 6.75547 2.44699 5.75547 3.17366 5.0288L2.22699 4.08214C1.26699 5.0488 0.666992 6.38214 0.666992 7.85547C0.666992 10.5755 2.70033 12.8155 5.33366 13.1421V11.7955C3.44699 11.4755 2.00033 9.83547 2.00033 7.85547ZM11.3337 7.85547C11.3337 4.9088 8.94699 2.52214 6.00033 2.52214C5.96033 2.52214 5.92032 2.5288 5.88032 2.5288L6.60699 1.80214L5.66699 0.855469L3.33366 3.1888L5.66699 5.52214L6.60699 4.58214L5.88699 3.86214C5.92699 3.86214 5.96699 3.85547 6.00033 3.85547C8.20699 3.85547 10.0003 5.6488 10.0003 7.85547C10.0003 9.83547 8.55366 11.4755 6.66699 11.7955V13.1421C9.30033 12.8155 11.3337 10.5755 11.3337 7.85547Z" fill="#2B0950"/>
			</svg>
			Go back
		</button>
	</>;
}
 
export default ChooseLink;